<template>
  <div class="admin-login-page" :style="{ backgroundImage: `url(${publicPath}login_background.png)` }">
    <div class="admin-login-card">
      <div class="admin-login-icon">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
          <rect width="48" height="48" rx="12" fill="#2b7de9" fill-opacity="0.1"/>
          <path d="M24 14c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0 4c-4 0-12 2-12 6v2h24v-2c0-4-8-6-12-6zm-10 6c.22-1.16 4.56-4 10-4s9.78 2.84 10 4H14z" fill="#2b7de9"/>
<!--          <path d="M35 20h-2v-2c0-1.1-.9-2-2-2s-2 .9-2 2v2h-2c-1.1 0-2 .9-2 2s.9 2 2 2h2v2c0 1.1.9 2 2 2s2-.9 2-2v-2h2c1.1 0 2-.9 2-2s-.9-2-2-2z" fill="#2b7de9" opacity="0.6"/>-->
        </svg>
      </div>
      <h2>管理后台登录</h2>
      <p class="admin-login-desc">仅限超级管理员访问</p>
      <form @submit.prevent="handleLogin">
        <div class="form-group">
          <div class="input-wrapper">
            <img src="/login_email.png" alt="" class="input-icon" />
            <input v-model="form.username" type="text" placeholder="请输入管理员账号" required />
          </div>
        </div>
        <div class="form-group">
          <div class="input-wrapper">
            <img src="/login_password.png" alt="" class="input-icon" />
            <input v-model="form.password" type="password" placeholder="请输入密码" required />
          </div>
        </div>
        <p class="error" v-if="errorMsg">{{ errorMsg }}</p>
        <button type="submit" class="btn-submit" :disabled="loading">
          {{ loading ? '登录中...' : '登 录' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import api from '../utils/api'

export default {
  name: 'AdminLogin',
  data() {
    return {
      form: { username: '', password: '' },
      loading: false,
      errorMsg: '',
      publicPath: process.env.BASE_URL
    }
  },
  methods: {
    async handleLogin() {
      this.errorMsg = ''
      this.loading = true
      try {
        var res = await api.post('/api/auth/login', this.form)
        if (res.code === 200) {
          if (res.data.role !== 1) {
            this.errorMsg = '该账号无管理员权限'
            this.loading = false
            return
          }
          localStorage.setItem('admin_token', res.data.token)
          localStorage.setItem('admin_username', res.data.username)
          this.$router.push('/manage/records')
        } else {
          this.errorMsg = res.message
        }
      } catch (e) {
        this.errorMsg = '网络错误，请稍后重试'
      }
      this.loading = false
    }
  }
}
</script>

<style scoped>
.admin-login-page {
  min-height: 100vh;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}
.admin-login-card {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-radius: 20px;
  padding: 48px 44px 40px;
  width: 400px;
  box-shadow: 0 8px 40px rgba(43, 125, 233, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.7);
  text-align: center;
}
.admin-login-icon { margin-bottom: 16px; }
h2 { font-size: 24px; font-weight: 700; color: #1a1a2e; margin: 0 0 8px; }
.admin-login-desc { font-size: 13px; color: #999; margin: 0 0 32px; }
.form-group { margin-bottom: 20px; }
.input-wrapper { position: relative; display: flex; align-items: center; }
.input-icon { position: absolute; left: 16px; width: 18px; height: 18px; object-fit: contain; opacity: 0.5; pointer-events: none; }
.input-wrapper input {
  width: 100%; padding: 14px 16px 14px 46px;
  border: 1px solid #e8ecf0; border-radius: 10px;
  font-size: 14px; color: #333;
  background: rgba(245, 247, 250, 0.7);
  outline: none; transition: all 0.25s; box-sizing: border-box;
}
.input-wrapper input::placeholder { color: #b0b8c4; }
.input-wrapper input:focus { border-color: #2b7de9; background: #fff; box-shadow: 0 0 0 3px rgba(43, 125, 233, 0.08); }
.error { color: #ef4444; font-size: 13px; margin: -4px 0 12px; }
.btn-submit {
  width: 100%; padding: 14px;
  background: linear-gradient(135deg, #2b7de9 0%, #1a6ad4 100%);
  color: #fff; border: none; border-radius: 10px;
  font-size: 16px; font-weight: 600; cursor: pointer;
  transition: all 0.25s; letter-spacing: 4px;
}
.btn-submit:hover { background: linear-gradient(135deg, #1a6ad4 0%, #1558b8 100%); box-shadow: 0 4px 16px rgba(43, 125, 233, 0.25); }
.btn-submit:disabled { background: linear-gradient(135deg, #93bff0 0%, #a8ccf4 100%); cursor: not-allowed; }
</style>
